import { criticalApi, handleApiResponse } from "@core/api/core"
import type { EncounterCollaborativeNote, EncounterComposedNote } from "@/types/encounter"

export const COLLABORATIVE_NOTE_CHANGED_EVENT = "encounter-collaborative-note-changed"

export const getMyCollaborativeNote = async (encounterUuid: string): Promise<EncounterCollaborativeNote> => {
  const response = await criticalApi.get(`/encounter/${encounterUuid}/collaborative-note/`)
  return handleApiResponse<EncounterCollaborativeNote>(response)
}

export const saveMyCollaborativeNote = async (
  encounterUuid: string,
  content: string,
  expectedRevision: number
): Promise<EncounterCollaborativeNote> => {
  const response = await criticalApi.patch(`/encounter/${encounterUuid}/collaborative-note/`, { content, expectedRevision })
  return handleApiResponse<EncounterCollaborativeNote>(response)
}

export const deleteMyCollaborativeNote = async (encounterUuid: string, expectedRevision: number): Promise<EncounterCollaborativeNote> => {
  const response = await criticalApi.delete(`/encounter/${encounterUuid}/collaborative-note/`, { data: { expectedRevision } })
  return handleApiResponse<EncounterCollaborativeNote>(response)
}

export const getEncounterComposedNote = async (encounterUuid: string): Promise<EncounterComposedNote> => {
  const response = await criticalApi.get(`/encounter/${encounterUuid}/composed-note/`)
  return handleApiResponse<EncounterComposedNote>(response)
}
